import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {DistributionAccount} from '../distribution-account/distribution-account.model';
import {selectAccounts, selectTargets} from './target.state';
import {TargetAccount} from './target.model';

@Injectable({
  providedIn: 'root'
})
export class TargetFacadeService {

  constructor(private store: Store) {
  }

  getAccountsFromTargets(): Observable<DistributionAccount[]> {
    return this.store.select(selectAccounts);
  };

  getTargets(): Observable<TargetAccount[]> {
    return this.store.select(selectTargets);
  };
}
